import {
  Component,
  forwardRef,
  inject,
  input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';

import { PortalConfig, PortalCredential } from '@ui/shared/model';

import { TranslatePipe } from '@ngx-translate/core';
import { BasePortalCredentialControl } from '../../controls/base-portal-credential.control';
import { FormFieldLabelComponent } from '../../../components/legacy/form/form-field/form-field-label/form-field-label.component';
import { FormFieldComponent } from '../../../components/legacy/form/form-field/form-field.component';
import { AppInputDirective } from '../../../components/legacy/form/controls/input/input.directive';

@Component({
  selector: 'app-resident-credential-details',
  templateUrl: './resident-credential-details.component.html',
  styleUrls: ['./resident-credential-details.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ResidentCredentialsDetailsComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    FormFieldLabelComponent,
    FormFieldComponent,
    AppInputDirective
  ]
})
export class ResidentCredentialsDetailsComponent
  extends BasePortalCredentialControl
  implements OnInit
{
  private fb = inject(FormBuilder);

  public readonly portalConfig = input<PortalConfig>(undefined);
  public readonly credential = input<PortalCredential>(undefined);

  constructor() {
    super();

    this.form = this.fb.group({
      name: ['', Validators.required],
      properties: {}
    });
  }

  public ngOnInit() {
    const credentialValue = this.credential();
    if (credentialValue) {
      this.form.patchValue(credentialValue);
    }

    this.form.valueChanges.subscribe(credential => {
      this.value = { ...credential };

      this.onChange(this.value);
      this.onTouch();
    });
  }
}
